export { default as CoreMarqueeModule } from './module';
